import React from 'react';
import { HStack, Text, VStack } from '@adc/parallax-component-library';
import { IconBack } from '@adc/parallax-icons';
import { IconButton } from 'Components/utility';
import mediator from 'Utilities/mediator';
import { ActionBarHeader } from './ActionBarHeader';
const TitleActionBar = ({ titleTestID: testIDTitle, actionButtonTestID: testIDActionButton, title, onBack, }) => {
    return (React.createElement(VStack, { style: {
            top: 0,
            left: 0,
            right: 0,
        }, backgroundColor: "$surface.container" },
        React.createElement(ActionBarHeader, null),
        React.createElement(HStack, { padding: "$4" },
            React.createElement(IconButton, { testID: testIDActionButton, onPress: () => {
                    onBack ? onBack() : mediator.publish('router:back');
                } },
                React.createElement(IconBack, { testID: `${testIDActionButton}-icon` })),
            React.createElement(Text, { testID: testIDTitle, color: "$text.100", fontSize: "$h4.strong", fontWeight: "$h4.strong", width: "100%", alignSelf: "center", textAlign: "center" }, title))));
};
export { TitleActionBar };
